module.exports = __webpack_public_path__ + "static/media/initiator.15d1ef17.png";